var _path, _path2;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgBxUserPin = function SvgBxUserPin(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4444 7.33312C13.4444 8.74112 12.4068 9.77756 11 9.77756C9.59442 9.77756 8.55553 8.74112 8.55553 7.33312C8.55553 5.92512 9.59442 4.88867 11 4.88867C12.4068 4.88867 13.4444 5.92512 13.4444 7.33312ZM6.11108 15.4C6.11108 12.9702 8.30008 11 11 11C13.6999 11 15.8889 12.9702 15.8889 15.4V15.8718H6.11108V15.4Z",
    fill: "#FF9400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44444 0H19.5556C20.9037 0 22 1.09633 22 2.44444V18.3333C22 19.6814 20.9037 20.7778 19.5556 20.7778H14.6667L11 24.4444L7.33333 20.7778H2.44444C1.09633 20.7778 0 19.6814 0 18.3333V2.44444C0 1.09633 1.09633 0 2.44444 0ZM11 20.7777L13.4445 18.3332H19.558L19.5556 2.44434H2.44446V18.3332H8.55557L11 20.7777Z",
    fill: "#FF9400"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBxUserPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bx-user-pin.f2f03f0e.svg";
export { ForwardRef as ReactComponent };